import './ComparisonHeader.css';const comparisonHeader = "_comparisonHeader_u9d4d_1";
const styles = {
  comparisonHeader
};
export {
  comparisonHeader,
  styles as default
};
